/* eslint-disable no-underscore-dangle */
import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import styled from 'styled-components';
import client from '../../../api/api';
import UploadImgBtn from '../UploadImgBtn';
import SideInfo from './SideInfo';
import Success from './Success';
import InputProvider from './InputProvider';
import resizeImage from '../../../libs/resizer/imageResizer';
import { LICENSE_OUTCOME } from './licenseOutcomeMessages';

const media = {
  tablet: '@media(min-width: 768px)',
  desktop: '@media(min-width: 1366px)',
};

const CardWrap = styled.form`
  background: #1f1e29;
  width: 100%;
  margin: 26px auto;
  padding: 5px 12px;

  h2 {
    color: white;
    margin: 10px;
  }

  .clear-btn {
    border: none;
    background: #ffbb0f;
    color: black;
    font-size: 12px;
    border-radius: 20px;
    padding: 5px 17px;
    margin: 10px 6px;
    white-space: normal;
    word-break: break-word;
    line-height: 1.2;
    min-height: 28px;
    max-width: calc(100% - 12px);
  }

  .clear-btn:focus {
    outline: none;
  }

  ${media.desktop} {
    border-radius: 20px;
    margin: 25px;
    width: 27pc;

    .clear-btn {
      color: black !important;
      margin: 0 0 0 12px;
      white-space: nowrap;
      max-width: none;
    }
  }
`;

const AddTruckerWrap = styled.div`
  color: #ffbb0f;
  padding: ${props => (props.isInModal ? '1pc 0 2pc 0' : '2pc 0 15pc 0')};
  margin: 0 auto;
  background-color: ${props => (props.isInModal ? 'transparent' : '#31354e')};
  display: flex;
  position: relative;
  flex-direction: column;
  min-height: ${props => (props.isInModal ? 'auto' : 'initial')};

  .step-index {
    display: inline-flex;
    width: 14px;
    height: 90px;
    margin: 17px 18px 0 0;
  }

  .premium-icon {
    display: inline-flex;
    width: 5pc;
    height: 5pc;
    margin: 20px;
  }

  img {
    width: 100%;
  }

  h3 {
    font-size: 30px;
  }

  ul {
    display: inline-block;
    color: white;
  }

  ul li {
    margin: 12px 0;
    font-size: 16px;
  }

  .items-wrap {
    display: flex;
  }

  .billing-data-ad {
    display: none;
  }

  .save-btn {
    position: absolute;
    background: #ffbb0f;
    color: gray;
    border-radius: 40px;
    border: none;
    width: 11pc;
    bottom: 50px;
    height: 34px;
    font-size: 19px;
    right: 48px;
    outline: none;
  }

  label {
    width: 90%;
    font-weight: 600;
    color: gray;
    margin: 10px 15px;
  }

  input {
    background: transparent;
    border: none;
    height: 45px;
    font-size: 16px;
    color: white;
    width: 100%;
    border-bottom: 1px solid #787878;
  }

  input:focus {
    outline: none;
  }

  ${media.tablet} {
    .premium-icon {
      margin: unset;
    }
  }

  ${media.desktop} {
    width: 100%;
    position: relative;

    .premium-icon {
      width: 6pc;
      height: 6pc;
      margin-right: 10px;
    }

    h3 {
      width: ${props => (props.isInModal ? '100%' : '47%')};
    }

    ul li {
      margin: 15px 0;
      font-size: 16px;
    }

    .side-info {
      position: ${props => (props.isInModal ? 'relative' : 'absolute')};
      height: ${props => (props.isInModal ? 'auto' : '79pc')};
      background: #1f2231;
      width: ${props => (props.isInModal ? '100%' : '28pc')};
      top: ${props => (props.isInModal ? 'auto' : '0')};
      right: ${props => (props.isInModal ? 'auto' : '0')};
      border-bottom-left-radius: 25px;
      border-bottom-right-radius: 25px;
      margin: ${props => (props.isInModal ? '20px 0' : '0')};
    }

    .billing-data-ad {
      display: flex;
      width: 100%;
      height: 13pc;
      justify-content: flex-end;
      align-items: flex-end;
    }

    .billing-data-ad p {
      color: white;
      padding: 20px;
    }

    .money-icon {
      width: 5pc;
      margin-left: 40px;
    }
  }
`;

const Row = styled.div`
  display: flex;
  justify-content: space-around;
  width: 100%;
  margin: 0 auto;
  position: relative;
  flex-direction: column;

  .truck-info {
    flex-direction: column;
  }

  ${media.desktop} {
    width: 60pc;
    flex-direction: row;

    .truck-info {
      width: 30pc;
      margin: 0;
    }
  }
`;

const Header = styled.div`
  margin: 0 auto;
  flex-direction: column;

  h3 {
    width: 100%;
    padding-left: 25px;
  }

  ${media.tablet} {
    display: flex;
    flex-direction: column;
    width: 90%;
    margin: 0 auto;

    img {
      width: 5pc;
      height: 5pc;
    }

    .premium-icon {
      margin: 17px;
    }
  }

  ${media.desktop} {
    display: flex;
    flex-direction: column;
    width: 60pc;

    img {
      width: 6pc;
      height: 6pc;
      margin: unset;
    }
  }
`;

const BillingInfo = styled.div`
  height: 2pc;
  width: 100%;
  padding: 0 16px;
  font-size: 12px;

  p {
    color: white;
  }
`;

const ErrorWrap = styled.div`
  width: 100%;
  background: red;
  display: flex;
  justify-content: center;

  p {
    color: white;
    padding: 10px;
  }
`;

const InfoWrap = styled.div`
  width: 100%;
  background: #1f2231;
  border-top: 1px solid #383d54;
  border-bottom: 1px solid #383d54;
  display: flex;
  justify-content: center;

  p {
    color: #ffbb0f;
    padding: 10px;
  }
`;

const SuccessInfoWrap = styled.div`
  width: 100%;
  background: #1f2231;
  border-top: 1px solid #2e7d32;
  border-bottom: 1px solid #2e7d32;
  display: flex;
  justify-content: center;

  p {
    color: #4caf50;
    padding: 10px;
    font-weight: 600;
  }
`;


const AddTrucker = forwardRef(({ onSuccess, isInModal = false, onStateChange }, ref) => {
  const [truckerCuit, setTruckerCuit] = useState('');
  const [truckerName, setTruckerName] = useState('');
  const [cellNumber, setCellNumber] = useState('');
  const [billingCuit, setBillingCuit] = useState('');
  const [legalName, setLegalName] = useState('');
  const [cbu, setCBU] = useState('');
  const [truckPatent, setTruckPatent] = useState('');
  const [trailerPatent, setTrailerPatent] = useState('');
  const [truckTypeSelected, setTruckTypeSelected] = useState('');
  const [bodyTypeSelected, setBodyTypeSelected] = useState('');
  const [billingDataId, setBillingDataId] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [truckId, setTruckId] = useState('');
  const [newTruckerId, setNewTruckerId] = useState('');

  const [licensePhoto, setLicensePhoto] = useState('');
  const [cuitValidated, setCuitValidated] = useState(false);
  const [validatingLicense, setValidatingLicense] = useState(false);
  const [licenseValidated, setLicenseValidated] = useState(false);
  const [successMsg, setSuccessMsg] = useState('');

  const [photosArr, setPhotosArr] = useState([]);
  const [truckerCreated, setTruckerCreated] = useState(false);
  const [creationOutcome, setCreationOutcome] = useState(null);
  const [loading, setLoading] = useState(false);
  const [billingDataBtnDisabled, setBillingDataBtnDisabled] = useState(false);

  const errorRef = useRef(null);

  const trucker = {
    truckerName,
    truckerCuit,
    cellNumber,
    billingCuit,
    cbu,
    legalName,
    truckPatent,
    trailerPatent,
    truckType: truckTypeSelected?.label,
    bodyType: bodyTypeSelected?.label,
  };

  const resetLicenseValidation = () => {
    setLicensePhoto('');
    setLicenseValidated(false);
    setValidatingLicense(false);
    setSuccessMsg('');
  };

  const handleRemoveLicensePhoto = () => {
    setErrorMsg('');
    resetLicenseValidation();
  };

  const cuitValidation = async cuit => {
    try {
      setErrorMsg('');
      setCuitValidated(false);
      resetLicenseValidation();

      if (cuit.length !== 11 && cuit !== '') {
        setErrorMsg('El CUIT debe tener 11 dígitos');
        return;
      }

      if (cuit !== '' && truckerName === '') {
        const res = await client.endpoints.carrier.getTruckerByCUIT(cuit);
        if (res.status === 200 && res.data._id) {
          setErrorMsg('El camionero ya existe en Humber, ingresá otro CUIT');
          setBillingDataBtnDisabled(true);
        } else {
          setTruckerName(res.data.name);
          setCuitValidated(true);
        }
      } else if (cuit !== '' && truckerName !== '') {
        setCuitValidated(true);
      }
    } catch (error) {
      setErrorMsg(error.response?.data?.message || 'Error validando CUIT');
    }
  };

  const handleLicensePhotoChange = async file => {
    setLicensePhoto(file);
    setLicenseValidated(false);
    setSuccessMsg('');

    if (!file || !cuitValidated || !truckerCuit) return;

    try {
      setValidatingLicense(true);
      setErrorMsg('');
      const res = await client.endpoints.carrier.validateTruckerLicensePreview(
        truckerCuit,
        file
      );
      if (res.status === 200 && res.data?.valid) {
        setLicenseValidated(true);
        setErrorMsg('');
        setSuccessMsg('Validación correcta');
      } else {
        setLicenseValidated(false);
        setErrorMsg('El registro no es válido o no coinciden los datos. Validaremos manualmente tus datos.');
      }
    } catch (error) {
      setLicenseValidated(false);
      setErrorMsg('El registro no es válido o no coinciden los datos. Validaremos manualmente tus datos.');
    } finally {
      setValidatingLicense(false);
    }
  };

  const billingCuitValidation = async cuit => {
    try {
      setErrorMsg('');
      setLegalName('');
      if (cuit !== '') {
        const res = await client.endpoints.generic.validateBillingCUIT(cuit, false, true, true);
        if (res.status === 200) {
          setLegalName(res.data.name);
          setBillingDataId(res.data.billingDataId ? res.data.billingDataId : '');
        }
      }
    } catch (error) {
      setErrorMsg(error.response.data.message);
    }
  };

  const buildValidationErrors = () => {
    const errors = [];
    const missingFields = [];
    if (!truckerCuit) missingFields.push('CUIT');
    if (!truckerName) missingFields.push('nombre del chofer');
    if (!cellNumber) missingFields.push('celular');
    if (!truckPatent) missingFields.push('patente tractor');
    if (!truckTypeSelected?._id) missingFields.push('tipo de camión');
    if (!trailerPatent) missingFields.push('patente remolque');
    if (!bodyTypeSelected?._id) missingFields.push('carrocería');

    if (missingFields.length > 0) {
      errors.push(`Completá los siguientes campos: ${missingFields.join(', ')}`);
    }
    if (validatingLicense) {
      errors.push('Esperá a que termine la validación del registro');
    }
    return errors;
  };

  const saveTrucker = async () => {
    const errors = buildValidationErrors();
    if (errors.length > 0) {
      setErrorMsg(errors.join('. '));
      return;
    }

    try {
      setLoading(true);
      setErrorMsg('');
      const formData = new FormData();
      formData.append('truckerCuit', truckerCuit);
      formData.append('truckerName', truckerName);
      formData.append('truckerCellPhone', cellNumber);
      if (truckPatent) {
        formData.append('truckPatent', truckPatent);
      }
      if (trailerPatent) {
        formData.append('trailerPatent', trailerPatent);
      }
      if (truckTypeSelected?._id) {
        formData.append('truckTypeId', truckTypeSelected._id);
      }
      if (bodyTypeSelected?._id) {
        formData.append('trailerBodyTypeId', bodyTypeSelected._id);
      }
      formData.append('provinceId', '2');
      formData.append('cityId', '3961');
      if (billingDataId) {
        formData.append('billingDataId', billingDataId);
      } else {
        formData.append('billingCuit', billingCuit);
        formData.append('bankAccount', cbu);
      }
      formData.append('satelliteTracking', false);
      const truckerForm = { formData };

      const res = await client.endpoints.carrier.addTrucker(truckerForm);
      if (res.status === 200) {
        const { newTrucker, newTruck } = res.data;
        await client.endpoints.carrier.syncTruckerVehicle(newTrucker._id, newTruck._id);
        setNewTruckerId(newTrucker._id);
        setTruckId(newTruck._id);
      } else if (res.status === 400) {
        setLoading(false);
        setErrorMsg('Se produjo un error');
      }
    } catch (error) {
      setLoading(false);
      setErrorMsg(error.response?.data?.message || 'Error al crear el camionero');
    }
  };

  const buildPhotosArray = () => {
    const photosList = [];
    if (licensePhoto !== '') {
      photosList.push({
        photoTag: 'Registro',
        photoName: 'truckerLicensePhoto',
        photoFile: licensePhoto,
      });
    }
    return photosList;
  };

  const markAsPremium = async () => {
    if (!licensePhoto || !licenseValidated) return false;
    try {
      await client.endpoints.carrier.validateTruckerLicense(
        newTruckerId,
        truckerCuit,
        licensePhoto,
        truckId
      );
      return true;
    } catch (error) {
      console.error('Error marking trucker as premium', error);
      return false;
    }
  };

  const syncUploadedLicensePhoto = async () => {
    if (!licensePhoto) return;
    await client.endpoints.carrier.syncTruckerLicensePhoto(newTruckerId, truckId);
  };

  const uploadPhotos = async () => {
    try {
      setErrorMsg('');
      const photosList = buildPhotosArray();
      let licensePhotoUploaded = false;
      // eslint-disable-next-line no-restricted-syntax
      for (const photo of photosList) {
        const { photoTag, photoName, photoFile } = photo;
        const resizedImage = await resizeImage({ file: photoFile });
        const formData = new FormData();
        formData.append('photoName', photoName);
        formData.append('photoFile', resizedImage);
        const data = { formData };
        const res = await client.endpoints.carrier.uploadPhotos(data, truckId);
        if (res.status === 200) {
          setPhotosArr(arr => [...arr, { nombre: photoTag, subida: true }]);
          if (photoName === 'truckerLicensePhoto') licensePhotoUploaded = true;
        }
        if (res.status === 400) {
          setPhotosArr(arr => [...arr, { nombre: photoName, subida: false }]);
        }
      }

      if (licensePhotoUploaded) {
        await syncUploadedLicensePhoto();
      }

      let outcome;
      if (!licensePhoto) {
        outcome = LICENSE_OUTCOME.NO_LICENSE;
      } else {
        const premiumOk = await markAsPremium();
        outcome = premiumOk ? LICENSE_OUTCOME.PREMIUM_OK : LICENSE_OUTCOME.LICENSE_INVALID;
      }

      setCreationOutcome(outcome);
      setLoading(false);
      setTruckerCreated(true);
      if (onSuccess) {
        setTimeout(() => {
          onSuccess();
        }, 7000);
      }
    } catch (error) {
      setLoading(false);
      setErrorMsg(error.response?.data || 'Error al subir fotos');
    }
  };

  useEffect(() => {
    if (truckId !== '') uploadPhotos();
  }, [truckId]);

  useEffect(() => {
    if (errorMsg && errorRef.current) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [errorMsg, errorRef]);

  useEffect(() => {
    if (errorMsg === 'El registro no es válido o no coinciden los datos. Validaremos manualmente tus datos.') {
      const timeoutId = setTimeout(() => setErrorMsg(''), 4000);
      return () => clearTimeout(timeoutId);
    }
    return undefined;
  }, [errorMsg]);

  useEffect(() => {
    if (onStateChange) {
      onStateChange({ loading, truckerCreated });
    }
  }, [loading, truckerCreated, onStateChange]);

  // Exponer funciones al componente padre cuando está en modal
  useImperativeHandle(ref, () => ({
    saveTrucker,
    loading,
  }), [loading, saveTrucker]);

  return (
    <>
      {errorMsg ? (
        <ErrorWrap>
          <p ref={errorRef}>{errorMsg}</p>
        </ErrorWrap>
      ) : (
        ''
      )}
      {validatingLicense && (
        <InfoWrap>
          <p>Validando registro...</p>
        </InfoWrap>
      )}
      {successMsg && !validatingLicense && !errorMsg && (
        <SuccessInfoWrap>
          <p>{successMsg}</p>
        </SuccessInfoWrap>
      )}
      {truckerCreated ? (
        <Success outcome={creationOutcome} />
      ) : (
        <AddTruckerWrap isInModal={isInModal}>
          <Header>
            <h3>Hacé premium a tu camionero con la foto del registro</h3>
            <div className="items-wrap">
              <div className="premium-icon">
                <img src="../../../images/icons/icono-premium.png" alt="premium-icon" />
              </div>
              <ul>
                <li>Registro de conducir</li>
              </ul>
            </div>
          </Header>
          <Row>
            <CardWrap>
              <h2>Chofer</h2>
              <InputProvider
                label="CUIT"
                value={truckerCuit}
                setValue={setTruckerCuit}
                id="cuit"
                onBlurValidation={cuitValidation}
                setErrorMsg={setErrorMsg}
                disabled={truckerCuit && truckerName}
              />
              <button
                className="clear-btn"
                type="button"
                onClick={() => {
                  setErrorMsg('');
                  setTruckerCuit('');
                  setTruckerName('');
                  setBillingDataBtnDisabled(false);
                  setCuitValidated(false);
                  resetLicenseValidation();
                }}
              >
                Ingresar otro CUIT
              </button>
              <button
                className="clear-btn"
                type="button"
                onClick={() => {
                  setErrorMsg('');
                  setBillingCuit(truckerCuit);
                  setLegalName(truckerName);
                }}
                disabled={billingDataBtnDisabled}
              >
                Usar como datos de facturación
              </button>
              <label htmlFor="trucker-name">
                Nombre chofer
                <input id="trucker-name" value={truckerName} disabled />
              </label>
              <InputProvider
                label="Celular"
                value={cellNumber}
                setValue={setCellNumber}
                id="cell-number"
                setErrorMsg={setErrorMsg}
              />
              <UploadImgBtn
                setImg={handleLicensePhotoChange}
                label="Registro"
                disabled={!cuitValidated}
                tooltip="Ingresá un CUIT válido para habilitar la carga del registro"
                onRemove={handleRemoveLicensePhoto}
              />
            </CardWrap>
            <CardWrap>
              <h2>Datos de facturación</h2>
              <InputProvider
                label="CUIT de facturación"
                value={billingCuit}
                setValue={setBillingCuit}
                id="cuit"
                setErrorMsg={setErrorMsg}
                onBlurValidation={billingCuitValidation}
              />
              <BillingInfo>
                <p>Ingresá un CUIT de facturación</p>
              </BillingInfo>
              <label htmlFor="legal-name">
                Razón social
                <input id="legal-name" value={legalName} disabled />
              </label>
              {!billingDataId ? (
                <InputProvider
                  label="CBU"
                  value={cbu}
                  setValue={setCBU}
                  id="cbu"
                  setErrorMsg={setErrorMsg}
                />
              ) : (
                <p>
                  El dato de facturación ya existe en Humber, no hace falta que ingreses el CBU.
                </p>
              )}
            </CardWrap>
          </Row>
          <Row>
            <CardWrap>
              <h2>Tractor</h2>
              <InputProvider
                label="Patente tractor"
                value={truckPatent}
                setValue={setTruckPatent}
                id="truck-patent"
                type="text"
                setErrorMsg={setErrorMsg}
              />
              <InputProvider
                label="Tipo de camión"
                value={truckTypeSelected}
                setValue={setTruckTypeSelected}
                id="truck-type"
                type="select"
                setErrorMsg={setErrorMsg}
              />
            </CardWrap>
            <CardWrap>
              <h2>Remolque</h2>
              <InputProvider
                label="Patente remolque"
                value={trailerPatent}
                setValue={setTrailerPatent}
                id="trailer-patent"
                type="text"
                setErrorMsg={setErrorMsg}
              />
              <InputProvider
                label="Carrocería"
                value={bodyTypeSelected}
                setValue={setBodyTypeSelected}
                id="truck-body-type"
                type="select"
                setErrorMsg={setErrorMsg}
              />
            </CardWrap>
          </Row>
          <Row>
            <SideInfo trucker={trucker} />
            {!isInModal && !loading && (
              <button className="save-btn" type="button" onClick={saveTrucker}>
                Guardar
              </button>
            )}
          </Row>
        </AddTruckerWrap>
      )}
    </>
  );
});

AddTrucker.displayName = 'AddTrucker';

export default AddTrucker;
